var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoToPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3336 6.11101C11.0127 6.11101 9.12796 6.56905 7.84867 7.84835C6.56937 9.12764 6.11133 11.0124 6.11133 13.3332V18.6666C6.11133 20.9874 6.56937 22.8722 7.84867 24.1514C9.12796 25.4307 11.0127 25.8888 13.3336 25.8888H18.6669C20.9877 25.8888 22.8725 25.4307 24.1518 24.1514C25.4311 22.8722 25.8891 20.9874 25.8891 18.6666V16.8888C25.8891 16.3365 25.4414 15.8888 24.8891 15.8888C24.3368 15.8888 23.8891 16.3365 23.8891 16.8888V18.6666C23.8891 20.7902 23.4583 22.0165 22.7376 22.7372C22.0168 23.4579 20.7905 23.8888 18.6669 23.8888H13.3336C11.21 23.8888 9.98359 23.4579 9.26288 22.7372C8.54217 22.0165 8.11133 20.7902 8.11133 18.6666V13.3332C8.11133 11.2096 8.54217 9.98327 9.26288 9.26256C9.98359 8.54185 11.21 8.11101 13.3336 8.11101H15.1113C15.6636 8.11101 16.1113 7.66329 16.1113 7.11101C16.1113 6.55872 15.6636 6.11101 15.1113 6.11101H13.3336ZM19.6224 7.11101C19.6224 6.55872 20.0701 6.11101 20.6224 6.11101H24.8891C25.4413 6.11101 25.8891 6.55872 25.8891 7.11101V11.3777C25.8891 11.93 25.4413 12.3777 24.8891 12.3777C24.3368 12.3777 23.8891 11.93 23.8891 11.3777V9.52498L17.5961 15.8179C17.2056 16.2085 16.5724 16.2085 16.1819 15.8179C15.7914 15.4274 15.7914 14.7943 16.1819 14.4037L22.4746 8.11101H20.6224C20.0701 8.11101 19.6224 7.66329 19.6224 7.11101Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToPost);
export default __webpack_public_path__ + "static/media/goToPost.44eabc74.svg";
export { ForwardRef as ReactComponent };